import React from 'react'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import CancelVoipServiceForm from '../forms/CancelVoipServiceForm'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'

class CancelVoipService extends React.Component {
    constructor (props) {
        super(props)

        this.type = 'mobile'
    }

    hasErrors () {
        return Object.keys(this.state.errors).length > 0
    }

    render () {
        return (
            <div>
                <div className='replacement-sim module' style={{ overflow: 'visible' }}>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded className='p-4'>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <p>You can cancel your service below:</p>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-6 offset-md-3'>
                                <CancelVoipServiceForm
                                    serviceId={this.props.serviceId}
                                    mobile={this.props.serviceDetails.serviceNo}
                                    endDate={this.props.serviceDetails.contractEndDate}
                                    handleSuccess={() => globals.pushEvent('CancelVoipServiceSubmit')}
                                />
                            </div>
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
            </div>
        )
    }
}

export default CancelVoipService



// WEBPACK FOOTER //
// ./resources/js/modules/CancelVoipService.js